import { PageHeader } from '@/design-system';
import { useHubUser } from '@/auth/hooks';
import { useEnvStore } from '@/env/envStore';
import { Navigate } from 'react-router-dom';

import { canApproveSelectedEnvironment } from './approvalAccess';
import { PendingDecisions } from './components/PendingDecisions';

export function ApprovalsPage() {
  const user = useHubUser();
  const env = useEnvStore((s) => s.env);
  const canApprove = canApproveSelectedEnvironment(user.groups, env);
  if (!canApprove) {
    return <Navigate to={env === 'corp' ? '/ai-tools' : '/elevation'} replace />;
  }

  return (
    <div>
      <PageHeader title="Approvals" description={`Pending elevation requests for ${env}.`} />
      <PendingDecisions />
    </div>
  );
}
